import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { common } from '@ocean/ui'
import virtualClassroomStudentRoutes from 'modules/virtualClassrooms/common/routing/studentRoutes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const EventDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "VirtualClassroomStudentEventDetails" */ 'modules/virtualClassrooms/student/EventDetails/pages/EventDetails'
    )
)

const EventDetailsRouting = () => (
  <Suspense fallback={<RouteChangeProgress />}>
    <Switch>
      <Route exact path={`${routes.root}/:eventId`} component={EventDetails} />
      <Redirect path='*' to={virtualClassroomStudentRoutes.root} />
    </Switch>
  </Suspense>
)

export default EventDetailsRouting
